import {Component, ReactNode} from "react";

type Props = {
  children: ReactNode
  fallback: (reset: () => void) => ReactNode
}

export default class ErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  reset = () => this.setState({ failed: false })

  render() {
    return this.state.failed ? this.props.fallback(this.reset) : this.props.children
  }
}
